import React, { useState } from 'react';
import { AddDatasetModal } from './AddDatasetModal';
import { DatasetDetailsModal } from './DatasetDetailsModal';
import { ErrorDetailsModal } from './ErrorDetailsModal';
export const DataSourcesView = () => {
  const [isAddDatasetModalOpen, setIsAddDatasetModalOpen] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  // Sample data for the table
  const datasets = [{
    id: 1,
    name: 'Historical Occupancy',
    source: 'RoomMaster',
    lastUpdate: '2023-05-15 08:30 AM',
    status: 'healthy',
    connection: 'API Pull (Hourly)'
  }, {
    id: 2,
    name: 'Historical Rates',
    source: 'RoomMaster',
    lastUpdate: '2023-05-15 09:15 AM',
    status: 'error',
    errorCount: 2,
    connection: 'API Pull (Daily)'
  }, {
    id: 3,
    name: 'Current COMPSET Rates',
    source: 'STR',
    lastUpdate: '2023-05-15 10:00 AM',
    status: 'healthy',
    connection: 'API Pull (Hourly)'
  }, {
    id: 4,
    name: 'Current COMPSET Occupancy',
    source: 'STR',
    lastUpdate: '2023-05-14 11:45 PM',
    status: 'error',
    errorCount: 1,
    connection: 'Manual Import'
  }, {
    id: 5,
    name: 'Current Occupancy',
    source: 'RoomMaster',
    lastUpdate: '2023-05-15 10:30 AM',
    status: 'healthy',
    connection: 'API Pull (Hourly)'
  }, {
    id: 6,
    name: 'COMPSET',
    source: 'AI Modeled',
    lastUpdate: '2023-05-15 11:45 AM',
    status: 'healthy',
    connection: 'AI Generated (Daily)'
  }];
  const handleViewClick = dataset => {
    setSelectedDataset(dataset);
    setIsDetailsModalOpen(true);
  };
  const handleViewErrors = () => {
    setIsDetailsModalOpen(false);
    setIsErrorModalOpen(true);
  };
  const handleBackToDataset = () => {
    setIsErrorModalOpen(false);
    setIsDetailsModalOpen(true);
  };
  return <div className="h-full" data-id="element-514">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-515">
        Data Settings
      </h2>
      <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-516">
        <div className="flex justify-between items-center mb-4" data-id="element-517">
          <h3 className="text-lg font-medium text-gray-700" data-id="element-518">Data Sources</h3>
          <div className="flex gap-2" data-id="element-519">
            <button className="px-3 py-2 flex items-center gap-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50" onClick={() => {}} data-id="element-520">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-521">
                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" data-id="element-522" />
              </svg>
              Refresh All
            </button>
            <button className="px-3 py-2 flex items-center gap-2 text-sm font-medium text-white bg-teal-500 rounded-md hover:bg-teal-600" onClick={() => setIsAddDatasetModalOpen(true)} data-id="element-523">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-524">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" data-id="element-525" />
              </svg>
              Add Dataset
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-526">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-527">
            <thead className="bg-gray-50" data-id="element-528">
              <tr data-id="element-529">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-530">
                  Dataset
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-531">
                  Source
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-532">
                  Last Update
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-533">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-534">
                  Connection
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-535">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-536">
              {datasets.map(dataset => <tr key={dataset.id} className="hover:bg-gray-50" data-id="element-537">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-538">
                    {dataset.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-539">
                    {dataset.source}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-540">
                    {dataset.lastUpdate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-541">
                    {dataset.status === 'healthy' ? <span className="flex items-center" data-id="element-542">
                        <svg className="h-5 w-5 text-green-500 mr-1.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-543">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-544" />
                        </svg>
                        Healthy
                      </span> : <span className="flex items-center" data-id="element-545">
                        <svg className="h-5 w-5 text-red-500 mr-1.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-546">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-547" />
                        </svg>
                        {dataset.errorCount}{' '}
                        {dataset.errorCount === 1 ? 'Error' : 'Errors'}
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-548">
                    {dataset.connection}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-549">
                    <div className="flex items-center gap-2" data-id="element-550">
                      <button className="text-blue-500 hover:text-blue-700 flex items-center" onClick={() => handleViewClick(dataset)} data-id="element-551">
                        <span data-id="element-552">View</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-553">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" data-id="element-554" />
                        </svg>
                      </button>
                      <button className="text-gray-400 hover:text-gray-600" data-id="element-555">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-556">
                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" data-id="element-557" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {isAddDatasetModalOpen && <AddDatasetModal onClose={() => setIsAddDatasetModalOpen(false)} data-id="element-558" />}
      {isDetailsModalOpen && selectedDataset && <DatasetDetailsModal dataset={selectedDataset} onClose={() => setIsDetailsModalOpen(false)} onViewErrors={handleViewErrors} data-id="element-559" />}
      {isErrorModalOpen && selectedDataset && <ErrorDetailsModal dataset={selectedDataset} onClose={() => setIsErrorModalOpen(false)} onBackToDataset={handleBackToDataset} data-id="element-560" />}
    </div>;
};